import script from "./TabByEmail.vue?vue&type=script&lang=ts&setup=true"
export * from "./TabByEmail.vue?vue&type=script&lang=ts&setup=true"

import "./TabByEmail.vue?vue&type=style&index=0&id=30d333e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30d333e8"]])

export default __exports__